export default function() {
  'ngInject';

  function progressStyle(percentValue) {
    return percentValue === 0 ? '2%' : `${percentValue}%`;
  }

  function progressClass(percentValue) {
    if (percentValue === 0) return 'progress-bar-danger';
    if (percentValue > 1 && percentValue <= 25) return 'progress-bar-warning';
    if (percentValue > 25 && percentValue <= 50) return 'progress-bar-info';
    if (percentValue > 50 && percentValue <= 75) return 'progress-bar-success';
    return 'progress-bar-primary';
  }

  return {
    restrict: 'A',
    scope: {
      progressValue: '<',
      index: '<',
      name: '='
    },
    link: function(scope, element) {
      if (Number.isNaN(scope.progressValue)) scope.progressValue = 0;
      const progress = progressClass(scope.progressValue);
      const width = progressStyle(scope.progressValue);
      element.addClass(progress);
      element.css({ width });
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/progressValue/index.js